import {
	type LoaderFunctionArgs,
	type MetaFunction,
	useLoaderData,
} from 'react-router'
import { SiteShell } from '#app/components/site/SiteShell'
import { LegalPage } from '#app/components/site/legal'
import { COOKIE_POLICY } from '#app/data/legal/cookies'
import { getAudience } from '#app/utils/site/audience.server'
import { siteContent } from '#app/utils/site/content'
import { siteLinks } from '#app/utils/site/site-links'
import { siteMeta } from '#app/utils/site/site-meta'

export const handle = { chrome: 'site' } as const
export const links = siteLinks()
export const meta: MetaFunction = () => siteMeta(siteContent.meta.cookies)

export async function loader({ request }: LoaderFunctionArgs) {
	return { audience: await getAudience(request) }
}

export default function CookiesRoute() {
	const { audience } = useLoaderData<typeof loader>()
	return (
		<SiteShell audience={audience}>
			<LegalPage doc={COOKIE_POLICY} />
		</SiteShell>
	)
}
